import React from 'react'
import styles from './index.module.scss'

function SectionTitle ({title}) {
    return (
        <div className={`sectionTitle lx-text-center ${styles.sectionTitle}`}>
            <span className="title lx-relative lx-fz26 lx-fwBold lx-text-color-theme">{ title }</span>
        </div>
    )
}

export default SectionTitle;